import { useState } from 'react'
import { Button } from '../../../../Components/StyledComponents';
import './AutoHideSetting.scss';
import Switch from '../../../../Components/Switch/Switch';
import RadioButtonGroup from '../../../../Components/RadioButtonGroup/RadioButtonGroup';
import Dropdown from '../../../../Components/Dropdown/Dropdown';

const AutoHideSetting = ({autoHideData, modifyAutoHide}) => {
    const [ UseAutoHide, setUseAutoHide ] = useState(autoHideData?.AutoHideInfo?.UseAutoHide ?? false);
    const [ DefaultVisible, setDefaultVisible ] = useState(autoHideData?.AutoHideInfo?.DefaultVisible ?? 'Hide');
    const [ Schedules, setSchedules ] = useState(autoHideData?.AutoHideInfo?.Schedules ?? []);

    const weekdayList = [
        { key: 'Mon', text: '월요일' },
        { key: 'Tue', text: '화요일' },
        { key: 'Wed', text: '수요일' },
        { key: 'Thu', text: '목요일' },
        { key: 'Fri', text: '금요일' },
        { key: 'Sat', text: '토요일' },
        { key: 'Sun', text: '일요일' }
    ];

    const to2Digits = num => String(num).padStart(2, "0");
    const isTimeFormat = str => /^([01]\d|2[0-3]):([0-5]\d)$/.test(str);
    const hourOptions = Array.from({ length: 24 }, (_, i) => ({value: i, key: `${to2Digits(i)}시`}));
    const minuteOptions = Array.from({ length: 60 }, (_, i) => ({value: i, key: `${to2Digits(i)}분`}));

    const addSchedules = () => {
        const newSchedules = [...Schedules, {
            Type: 'Weekly',
            DaysOfWeek: [],
            StartTime: "00:00",
            EndTime: "00:00",
        }]
        setSchedules([...newSchedules])
    }

    const removeSchedules = (index) => {
        let newSchedules = [...Schedules];
        newSchedules.splice(index, 1);
        setSchedules([...newSchedules]);
    }

    const checkDay = (list, day) => {
        return list.some(item => item === day)
    }

    const onClickWeekDay = (scheduleIndex, daysKey) => {
        let newSchedules = [...Schedules];
        const findIndex = newSchedules[scheduleIndex].DaysOfWeek.findIndex(item => item === daysKey)
        if(findIndex >= 0) {
            newSchedules[scheduleIndex].DaysOfWeek.splice(findIndex, 1);
        } else {
            newSchedules[scheduleIndex].DaysOfWeek.push(daysKey);
        }
        setSchedules([...newSchedules]);
    };

    const getHourText = (time) => {
        if(typeof time === 'undefined' || time === null) return '00'
        else return time.split(":")[0]
    };

    const getMinuteText = (time) => {
        if(typeof time === 'undefined' || time === null) return '00'
        else return time.split(":")[1]
    };

    const onClickTime = (scheduleIndex, scheduleTimeKey, timeKey, value) => {
        let newSchedules = [...Schedules];
        let newTime = "00:00";
        if(timeKey === 'hour') newTime = to2Digits(value) + ':' + getMinuteText(newSchedules[scheduleIndex][scheduleTimeKey]);
        else if(timeKey === 'min') newTime = getHourText(newSchedules[scheduleIndex][scheduleTimeKey]) + ':' + to2Digits(value);
        newSchedules[scheduleIndex][scheduleTimeKey] = newTime;
        setSchedules([...newSchedules]);
    }

    const checkDisabled = () => {
        if(UseAutoHide && Schedules.length <= 0) return true;
        else if(DefaultVisible !== 'Hide' && DefaultVisible !== 'Show') return true;
        else if (checkSchedulesError()) return true;
    }

    const checkSchedulesError = () => {
        return Schedules.some(item => {
            if(item.DaysOfWeek.length <= 0) return true;
            else if(isTimeFormat(item.StartTime) === false) return true;
            else if(isTimeFormat(item.EndTime) === false) return true;
        })
    }

    const patch = () => {
        modifyAutoHide(autoHideData._id.$oid, {UseAutoHide, DefaultVisible, Schedules});
    }


    return (
        <div>
            <div className='info-box' style= {{padding: 0, borderWidth: 0, margin: '24px 0'}}>
                <div className='row between'>
                    <p className='info-box-title' style={{color: '#000'}}>자동 숨기기 기능 사용</p>
                    <Switch value={UseAutoHide} id="usestaffcall_switch" onChange={(val) => setUseAutoHide(val)} />
                </div>
            </div>
            <div className='info-box' style= {{padding: 0, borderWidth: 0, margin: '24px 0'}}>
                <div className='row between'>
                    <p className='info-box-title' style={{color: '#000'}}>숨김/노출 여부</p>
                    <div style={{width: 200}}>
                        <RadioButtonGroup
                            perRows={2}
                            value={DefaultVisible}
                            id='line'
                            onChange={(value) => { setDefaultVisible(value) }}
                            options={[
                                { label: '숨김', value: 'Hide' },
                                { label: '노출', value: 'Show' },
                            ]}
                            containerStyle={{ justifyContent: 'center' }}
                        />
                    </div>
                </div>
            </div>

            <div className='divider' />
            <div className='info-box' style= {{padding: 0, borderWidth: 0, margin: '24px 0'}}>
                <div className='row between' style={{alignItems: 'flex-start'}}>
                    <p className='info-box-title' style={{color: '#000'}}>스케줄</p>
                    <div className='auto-hide-schedules-list-container'>
                        <div className='auto-hide-schedules-list'>
                            {
                                Schedules.length > 0 ? (
                                    Schedules.map((schedule, index) => (
                                        <div key={index} className='row' style={{columnGap: 12}}>
                                            <div>
                                                <div className='schedules-weekday-btn-group'>
                                                    {weekdayList.map((days) => (
                                                        <Button
                                                            key={days.key}
                                                            variant={checkDay(schedule.DaysOfWeek, days.key) ? 'main' : "outline"}
                                                            className='schedules-weekday-btn'
                                                            fontSize={12}
                                                            onClick={() => onClickWeekDay(index, days.key)}
                                                            style={{padding: 0}}
                                                        >
                                                            {days.text}
                                                        </Button>
                                                    ))}
                                                </div>
                                                <div className='row' style={{flex: 1, justifyContent: 'space-between'}}>
                                                    <div className='row' style={{ marginBottom: 8, marginTop: 16 }}>
                                                        <Dropdown
                                                            id='oper-all-starthour'
                                                            options={hourOptions}
                                                            width={100}
                                                            onItemClick={val => onClickTime(index, 'StartTime', 'hour', val)}
                                                            btnStyle={{ marginRight: 16 }}
                                                            prefix={'시'}
                                                            value={getHourText(schedule.StartTime)}
                                                        />
                                                        <Dropdown
                                                            id='oper-all-startmin'
                                                            options={minuteOptions}
                                                            width={100}
                                                            onItemClick={val => onClickTime(index, 'StartTime', 'min', val)}
                                                            value={getMinuteText(schedule.StartTime)}
                                                            prefix={'분'}
                                                        />
                                                    </div>
                                                    <span className='info-box-title' style={{color: '#000', margin: 0}}>~</span>
                                                    <div className='row' style={{ marginBottom: 8, marginTop: 16 }}>
                                                        <Dropdown
                                                            id='oper-all-endhour'
                                                            options={hourOptions}
                                                            width={100}
                                                            onItemClick={val => onClickTime(index, 'EndTime', 'hour', val)}
                                                            value={getHourText(schedule.EndTime)}
                                                            btnStyle={{ marginRight: 16 }}
                                                            prefix={'시'}
                                                        />
                                                        <Dropdown
                                                            id='oper-all-endmin'
                                                            options={minuteOptions}
                                                            width={100}
                                                            onItemClick={val => onClickTime(index, 'EndTime', 'min', val)}
                                                            value={getMinuteText(schedule.EndTime)}
                                                            prefix={'분'}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <Button variant="sub" onClick={()=> removeSchedules(index)} style={{ width : 28, height : 28, borderRadius : 100, boxSizing : 'border-box', padding : 0 }}>
                                                <img src={require('../../../../aseets/icons/minus_pink.svg').default} style={{ width : 24, height : 24, marginTop : 2 }} />
                                            </Button>
                                        </div>
                                    ))
                                ) : (
                                    <p className='info-sub-title'>스케줄이 비어있습니다.</p>
                                )
                            }
                        </div>
                        <Button variant="main" fontSize={14} style={{ height : 32, padding: '0 12px', marginTop: 16 }} onClick={() => addSchedules()}>
                            추가하기
                        </Button>
                    </div>
                </div>
            </div>
            <div className='btn-row'>
                <Button variant="main" className='save-btn' fontSize={16} onClick={() => patch()} disabled={ checkDisabled() }>
                    설정하기
                </Button>
            </div>
        </div>
    )
}

export default AutoHideSetting;